import React, { ReactNode } from 'react'

import { Container } from '../Container'
import { Flex } from '../Flex'
import { IconButton } from '../IconButton'
import { Space } from '../Space'
import { Text } from '../Text'
import { ModuleContent } from './elements/ModuleContent'
import * as Styled from './styles'

export interface ModuleLayoutProps {
  backButtonTo?: string
  children?: ReactNode
  fullHeight?: boolean
  fullWidth?: boolean
  headerBottomActions?: ReactNode
  headerContent?: ReactNode
  onBackButtonClick?: () => void
  resetScroll?: boolean
  restoreScroll?: boolean
  sideActions?: ReactNode
  subtitle?: ReactNode
  title?: ReactNode
  withBackButton?: boolean
  withMenuOffset?: boolean
}

export const ModuleLayout = ({
  backButtonTo,
  children,
  fullHeight,
  fullWidth,
  headerBottomActions,
  headerContent,
  onBackButtonClick,
  resetScroll = false, // this prop is used to enable resetting scroll position on route change
  restoreScroll = true, // restoring scroll position after re-entering ModuleLayout is a default behaviour
  sideActions,
  subtitle,
  title,
  withBackButton,
  withMenuOffset = true,
}: ModuleLayoutProps) => {
  return (
    <Styled.ModuleLayoutWrapper>
      <Styled.ModuleStickyHeader>
        <Container fullWidth>
          <Styled.Header withMenuOffset={withMenuOffset}>
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center">
                {withBackButton && (
                  <Styled.BackButtonWrapper onClick={onBackButtonClick}>
                    <IconButton to={backButtonTo} icon="chevronLeft" />
                  </Styled.BackButtonWrapper>
                )}
                {title && (
                  <Flex flexDirection="column">
                    <Text variant="h1">{title}</Text>
                    {subtitle && <Text as="h2">{subtitle}</Text>}
                  </Flex>
                )}
              </Flex>

              {headerContent && (
                <>
                  <Space horizontal />
                  <Flex flexGrow={1}>{headerContent}</Flex>
                </>
              )}
              {sideActions && <Styled.SideActions>{sideActions}</Styled.SideActions>}
            </Flex>
          </Styled.Header>
          {headerBottomActions && (
            <Styled.HeaderBottomActionsWrapper>{headerBottomActions}</Styled.HeaderBottomActionsWrapper>
          )}
        </Container>
      </Styled.ModuleStickyHeader>

      {children && (
        <ModuleContent
          fullHeight={fullHeight}
          fullWidth={fullWidth}
          resetScroll={resetScroll}
          restoreScroll={restoreScroll}
        >
          {children}
        </ModuleContent>
      )}
    </Styled.ModuleLayoutWrapper>
  )
}
